import moment from "moment";
import React from "react";
import PropTypes from "prop-types";
import { formatPhoneNumber } from "../../utils/phoneFormatting";
import { getLicenseFieldConfig } from "../../config/professionalServices";

function ProfileDetailHeader({ getUserDetail, handleClick }) { // NOSONAR
  return (
    <div className="profile_title_grid d-flex justify-content-between align-items-center pb-3">
      <div>
        <p className="m-0 p-0 fs-5 fw-medium">Details</p>
        <p className="lastUpdatedText">
          Last Updated{" "}
          {moment(getUserDetail?.updatedAt).format("MM/DD/YYYY h:mm a ")}        </p>
      </div>
      <div className="btn_sec_right color_change">
        <button
          className="profile_edit_btn rounded-pill text-white"
          onClick={handleClick}
        >
          Edit
        </button>
      </div>
    </div>
  );
}

function AttorneyRoleColumns({ getUserDetail }) { // NOSONAR
  if (getUserDetail?.role !== 3 && getUserDetail?.role !== 6) { // NOSONAR
    return null;
  }
  const licenseConfig = getLicenseFieldConfig(
    getUserDetail?.role, // NOSONAR
    getUserDetail?.professionalServiceType // NOSONAR
  );
  return (
    <>
      <div className="col-md-4 col-lg-3 col-xl-2 pt-2">
        <div className="form-group">
          <p className="profile_section_label">{licenseConfig.label}</p>
          <p className="profile_main_part_user_detail_profile">
            {getUserDetail?.barNumber}          </p>
        </div>
      </div>
      <div className="col-md-4 col-lg-3 col-xl-2 pt-2">
        <div className="form-group">
          <p className="profile_section_label">State Licensed</p>
          <p className="profile_main_part_user_detail_profile">
            {getUserDetail?.stateLicensed}          </p>
        </div>
      </div>
      <div className="col-md-4 col-lg-3 col-xl-2 pt-2">
        <div className="form-group col-xl-">
          <p className="profile_section_label"> Firm (if applicable)</p>
          <p className="profile_main_part_user_detail_profile">
            {getUserDetail?.firm}          </p>
        </div>
      </div>
    </>
  );
}

function DrivingLicenseColumn({ title, field, getUserDetail, onDownload }) { // NOSONAR
  const val = getUserDetail?.[field];
  const isEmpty = val === undefined || val === "";
  return (
    <div className="col-md-4 col-lg-3 col-xl-2 pt-2">
      <div className="form-group">
        <p className="profile_section_label">{title}</p>
        <div className="files-wr" data-count-files="1">
          <button
            onClick={isEmpty ? () => {} : () => onDownload(val)}
            className="bg-white"
          >
            <div className="one-file d-flex align-items-center">
              <div className="d-flex">
                {isEmpty ? (
                  <>{""}</>
                ) : (
                  <>
                    <p className="profile_section_label see-attachment-text">
                      See Attachment
                    </p>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17.8019 15.1533V18.0196H6.33666V15.1533H4.42578V18.0196C4.42578 19.0706 5.28567 19.9305 6.33666 19.9305H17.8019C18.8529 19.9305 19.7128 19.0706 19.7128 18.0196V15.1533H17.8019ZM16.8465 11.3316L15.4993 9.98439L13.0247 12.4494V4.64349H11.1138V12.4494L8.63926 9.98439L7.29209 11.3316L12.0693 16.1087L16.8465 11.3316Z"
                        fill="#3F76C8"
                      />
                    </svg>
                  </>
                )}
              </div>
              <input name={field} id={field} />
              <div className="file-item hide-btn"></div>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}

function GrantorLicenseColumns({ getUserDetail, downloadImageFront, downloadImageBack }) { // NOSONAR
  if (getUserDetail?.role === 3 || getUserDetail?.role === 6) { // NOSONAR
    return null;
  }
  return (
    <>
      <DrivingLicenseColumn
        title="Drivers License - Front"
        field="drivingLicenseFront"
        getUserDetail={getUserDetail}
        onDownload={downloadImageFront}
      />
      <DrivingLicenseColumn
        title="Drivers License - Back"
        field="drivingLicenseBack"
        getUserDetail={getUserDetail}
        onDownload={downloadImageBack}
      />
    </>
  );
}

function ProfileAddressDobSsn({ getUserDetail, maskify }) { // NOSONAR
  return (
    <>
      <div className="col-md-4 col-lg-3 col-xl-2 pt-2">
        <div className="form-group">
          <p className="profile_section_label">Address Line 1</p>
          <p className="profile_main_part_user_detail_profile">
            {getUserDetail?.address1}          </p>
        </div>
      </div>
      <div className="col-md-4 col-lg-3 col-xl-2 pt-2">
        <div className="form-group">
          <p className="profile_section_label">Address Line 2</p>
          <p className="profile_main_part_user_detail_profile">
            {getUserDetail?.address2}          </p>
        </div>
      </div>
      <div className="col-md-4 col-lg-3 col-xl-2 pt-2">
        <div className="form-group">
          <p className="profile_section_label">City</p>
          <p className="profile_main_part_user_detail_profile">
            {getUserDetail?.city}          </p>
        </div>
      </div>
      <div className="col-md-4 col-lg-3 col-xl-2 pt-2">
        <div className="form-group">
          <p className="profile_section_label">State</p>
          <p className="profile_main_part_user_detail_profile">
            {getUserDetail?.state}          </p>
        </div>
      </div>
      <div className="col-md-4 col-lg-3 col-xl-2 pt-2">
        <div className="form-group">
          <p className="profile_section_label">Zip Code</p>
          <p className="profile_main_part_user_detail_profile">
            {getUserDetail?.zipCode}          </p>
        </div>
      </div>
      <div className="col-md-4 col-lg-3 col-xl-2 pt-2">
        <div className="form-group">
          <p className="profile_section_label">Date of Birth</p>
          <p>
            {getUserDetail?.dob // NOSONAR
              ? moment(getUserDetail.dob).format("MM/DD/YYYY") // NOSONAR
              : ""}
          </p>
        </div>
      </div>
      {(getUserDetail?.role === 2 || getUserDetail?.role === 4) && ( // NOSONAR
        <div className="col-md-4 col-lg-3 col-xl-2 pt-2">
          <div className="form-group">
            <p htmlFor="ssnNumber" className="profile_section_label">
              SSN / ITIN
            </p>
            <p className="profile_main_part_user_detail_profile">
              {`${
                getUserDetail?.ssnNumber // NOSONAR
                  ? "***-**-" + maskify(getUserDetail?.ssnNumber) // NOSONAR
                  : ""
              }`}
            </p>
          </div>
        </div>
      )}
    </>
  );
}

function ProfileUpgradeFooter({ isChildInfo, getUserDetail, setShowPopup }) { // NOSONAR
  if (isChildInfo || getUserDetail?.role !== 4) { // NOSONAR
    return null;
  }
  return (
    <button
      className="btn mt-3 mx-2 upgrade-successor-btn"
      onClick={(e) => {
        e.preventDefault();
        setShowPopup(true);
      }}
    >
      Upgrade Account
    </button>
  );
}

export default function ProfileDetailCard({
  getUserDetail,
  handleClick,
  downloadImageFront,
  downloadImageBack,
  setShowPopup,
  currentUnixTimestamp,
  maskify,
  isChildInfo,
}) {
  return (
    <>
      <div className="profile_main_sec_detail">
        <ProfileDetailHeader
          getUserDetail={getUserDetail}
          handleClick={handleClick}
        />
        <div className="">
          <div className="main_grid_top grid-container gap-0 pt-2">
            <div className="row m-0 w-100">
              <div className="col-md-4 col-lg-3 col-xl-2 pt-2">
                <div className="form-group">
                  <p className="profile_section_label">First Name</p>
                  <p className="profile_main_part_user_detail_profile">
                    {getUserDetail?.firstName}
                  </p>
                </div>
              </div>
              <div className="col-md-4 col-lg-3 col-xl-2 pt-2">
                <div className="form-group">
                  <p className="profile_section_label">Last Name</p>
                  <p className="profile_main_part_user_detail_profile">
                    {getUserDetail?.lastName}
                  </p>
                </div>
              </div>
              <div className="col-md-4 col-lg-3 col-xl-2 pt-2">
                <div className="form-group">
                  <p className="profile_section_label">Phone Number</p>
                  <p className="profile_main_part_user_detail_profile ">
                    {formatPhoneNumber(getUserDetail?.phoneNumber || "")}
                  </p>
                </div>
              </div>
              <div className="col-md-4 col-lg-3 col-xl-2 pt-2">
                <div className="form-group">
                  <p className="profile_section_label">Email address</p>
                  <p className="profile_main_part_user_detail_profile ">
                    {getUserDetail?.email}
                  </p>
                </div>
              </div>
              <AttorneyRoleColumns getUserDetail={getUserDetail} />
              <GrantorLicenseColumns
                getUserDetail={getUserDetail}
                downloadImageFront={downloadImageFront}
                downloadImageBack={downloadImageBack}
              />
              <ProfileAddressDobSsn
                getUserDetail={getUserDetail}
                maskify={maskify}
              />
            </div>
          </div>
        </div>
      </div>
      <ProfileUpgradeFooter
        isChildInfo={isChildInfo}
        getUserDetail={getUserDetail}
        setShowPopup={setShowPopup}
      />
    </>
  );
}

ProfileDetailCard.propTypes = {
  getUserDetail: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    phoneNumber: PropTypes.string,
    email: PropTypes.string,
    updatedAt: PropTypes.string,
    role: PropTypes.number,
    address1: PropTypes.string,
    address2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zipCode: PropTypes.string,
    dob: PropTypes.string,
    ssnNumber: PropTypes.string,
    drivingLicenseFront: PropTypes.string,
    drivingLicenseBack: PropTypes.string,
    barNumber: PropTypes.string,
    stateLicensed: PropTypes.string,
    firm: PropTypes.string,
    professionalServiceType: PropTypes.string,
  }),
  handleClick: PropTypes.func.isRequired,
  downloadImageFront: PropTypes.func.isRequired,
  downloadImageBack: PropTypes.func.isRequired,
  setShowPopup: PropTypes.func.isRequired,
  currentUnixTimestamp: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  maskify: PropTypes.func.isRequired,
  isChildInfo: PropTypes.bool,
};
